(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  // Entrada escalonada
  const reveals = $$('[data-reveal]');
  reveals.forEach((el, i) => { el.style.transitionDelay = ((i % 4) * 0.08) + 's'; });
  const io = new IntersectionObserver(entries => entries.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('visto'); io.unobserve(e.target); }
  }), { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  reveals.forEach(el => io.observe(el));

  // Contadores
  const fmt = n => n.toLocaleString('es-ES', { useGrouping: 'always' });
  const cio = new IntersectionObserver(entries => entries.forEach(e => {
    if (!e.isIntersecting) return;
    const el = e.target; cio.unobserve(el);
    const to = +el.dataset.count, suf = el.dataset.suffix || '';
    if (reduce) { el.textContent = fmt(to) + suf; return; }
    const t0 = performance.now();
    const tick = t => {
      const p = Math.min(1, (t - t0) / 1400);
      el.textContent = fmt(Math.round(to * (1 - Math.pow(1 - p, 3)))) + suf;
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }), { threshold: 0.6 });
  $$('[data-count]').forEach(el => cio.observe(el));

  // Barra de progreso + parallax (solo pantallas grandes)
  const bar = document.querySelector('[data-bar]');
  const px = $$('[data-parallax]');
  const grande = matchMedia('(min-width: 901px)');
  let raf = 0;
  const onScroll = () => {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = 0;
      const max = document.documentElement.scrollHeight - innerHeight;
      if (bar) bar.style.width = (max > 0 ? scrollY / max * 100 : 0) + '%';
      px.forEach(el => {
        if (reduce || !grande.matches) { el.style.transform = ''; return; }
        const r = el.getBoundingClientRect();
        const off = (r.top + r.height / 2 - innerHeight / 2) * -(+el.dataset.parallax || 0.05);
        el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
      });
    });
  };
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll);
  onScroll();

  // Halo que sigue al puntero
  const glow = document.querySelector('[data-glow]');
  if (glow && !reduce && matchMedia('(pointer: fine)').matches) {
    addEventListener('pointermove', ev => {
      glow.style.marginLeft = ((ev.clientX / innerWidth - 0.5) * 90).toFixed(1) + 'px';
      glow.style.marginTop = ((ev.clientY / innerHeight - 0.5) * 60).toFixed(1) + 'px';
    }, { passive: true });
  }

  // Reloj de Huelva y marca de "ahora" en el horario
  const reloj = document.querySelector('[data-reloj]');
  const dias = $$('[data-dias] .dia');
  const ahora = () => {
    if (!reloj && !dias.length) return;
    const p = Object.fromEntries(new Intl.DateTimeFormat('es-ES', { timeZone: 'Europe/Madrid', hour: '2-digit', minute: '2-digit', weekday: 'short', hourCycle: 'h23' })
      .formatToParts(new Date()).map(x => [x.type, x.value]));
    const h = +p.hour, m = +p.minute;
    if (reloj) reloj.textContent = 'HUELVA · ' + p.hour + ':' + p.minute;
    const idx = ['lun', 'mar', 'mié', 'jue', 'vie', 'sáb', 'dom'].indexOf(p.weekday.replace('.', '').toLowerCase());
    dias.forEach((d, i) => {
      d.classList.toggle('dia--hoy', i === idx);
      let mk = d.querySelector('.dia__ahora');
      if (i === idx) {
        if (!mk) { mk = document.createElement('span'); mk.className = 'dia__ahora'; d.querySelector('.dia__barra').appendChild(mk); }
        mk.style.left = ((h * 60 + m) / 1440 * 100).toFixed(2) + '%';
      } else if (mk) mk.remove();
    });
  };
  ahora(); setInterval(ahora, 15000);

  // Puntos de los carruseles móviles
  $$('[data-carrusel]').forEach(fila => {
    const puntos = fila.parentElement.querySelector('[data-puntos]');
    if (!puntos) return;
    const n = fila.children.length;
    if (!n) return;
    puntos.innerHTML = '<i></i>'.repeat(n);
    const is = $$('i', puntos);
    const pinta = () => {
      const w = fila.children[0].getBoundingClientRect().width + 12;
      const alFinal = fila.scrollLeft >= fila.scrollWidth - fila.clientWidth - 4;
      const k = alFinal ? n - 1 : Math.max(0, Math.min(n - 1, Math.round(fila.scrollLeft / w)));
      is.forEach((el, i) => el.classList.toggle('on', i === k));
    };
    fila.addEventListener('scroll', pinta, { passive: true });
    pinta();
  });


  // ---------- Menú móvil ----------
  const btnMenu = document.querySelector('.menu-btn');
  const nav = document.getElementById('menu');
  if (btnMenu && nav) {
    const cerrar = () => { nav.classList.remove('abierto'); btnMenu.setAttribute('aria-expanded', 'false'); btnMenu.setAttribute('aria-label', 'Abrir menú'); };
    btnMenu.addEventListener('click', () => {
      const abre = !nav.classList.contains('abierto');
      nav.classList.toggle('abierto', abre);
      btnMenu.setAttribute('aria-expanded', String(abre));
      btnMenu.setAttribute('aria-label', abre ? 'Cerrar menú' : 'Abrir menú');
    });
    nav.addEventListener('click', e => { if (e.target.closest('a')) cerrar(); });
    addEventListener('keydown', e => { if (e.key === 'Escape') cerrar(); });
  }

  // ---------- Aviso flotante ----------
  let toast = document.querySelector('[data-toast]'), tToast = 0;
  const avisar = txt => {
    if (!toast) return;
    toast.innerHTML = txt; toast.classList.add('visible');
    clearTimeout(tToast); tToast = setTimeout(() => { toast.classList.remove('visible'); toast.innerHTML = ''; }, 4000);
  };

  // ---------- Añadir a la cesta sin recargar ----------
  const contador = document.querySelector('[data-cesta-n]');
  const pintaCesta = n => {
    if (!contador) return;
    contador.textContent = n;
    contador.setAttribute('aria-label', n + ' productos');
    if (!reduce) { contador.classList.remove('salta'); void contador.offsetWidth; contador.classList.add('salta'); }
  };
  $$('[data-anadir-form]').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const boton = form.querySelector('button');
      boton.disabled = true;
      // Solo se recurre al envío normal si la petición no llegó a la tienda; si llegó, nunca se repite
      let r;
      try {
        r = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      } catch (err) {
        boton.disabled = false;
        form.submit();
        return;
      }
      try {
        if (!r.ok) {
          const error = await r.json().catch(() => ({}));
          avisar(error.description || 'No se ha podido añadir. Inténtalo de nuevo.');
          return;
        }
        avisar('Añadido a la cesta · <a href="/cart" style="text-decoration:underline">Ver cesta</a>');
        const cesta = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
        pintaCesta(cesta.item_count);
      } catch (err) {
        // La cesta ya se actualizó; el contador se corrige al recargar
      } finally {
        boton.disabled = false;
      }
    });
  });

  // ---------- Cantidad en la ficha ----------
  const valor = document.querySelector('[data-cant-valor]');
  if (valor) {
    $$('[data-cant]').forEach(b => b.addEventListener('click', () => {
      const n = Math.max(1, Math.min(20, (parseInt(valor.value, 10) || 1) + (+b.dataset.cant)));
      valor.value = n;
    }));
  }

  // ---------- Variantes: precio y botón según la elegida ----------
  const fProd = document.getElementById('form-producto');
  if (fProd) {
    const precio = document.querySelector('[data-precio]:not(input)');
    const btn = fProd.querySelector('.ficha__anadir');
    fProd.addEventListener('change', e => {
      const v = e.target.closest('input[type="radio"][name="id"]');
      if (!v) return;
      if (precio && v.dataset.precio) precio.textContent = v.dataset.precio;
      if (btn) { btn.disabled = v.disabled; btn.textContent = v.disabled ? 'Agotado' : 'Añadir a la cesta'; }
      const u = new URL(location.href); u.searchParams.set('variant', v.value); history.replaceState(null, '', u);
    });
  }
})();
